import { create } from 'zustand';

export type WorkspaceView = 'graph' | 'inputs' | 'sheet' | 'scenarios' | 'results';
export type WorkspaceViewIcon = 'network' | 'sliders' | 'table' | 'branch' | 'chart';

export interface WorkspaceViewDefinition {
  id: WorkspaceView;
  label: string;
  route: string;
  icon: WorkspaceViewIcon;
  description: string;
  requiresSimulation: boolean;
}

export const DEFAULT_WORKSPACE_VIEW: WorkspaceView = 'graph';

export const WORKSPACE_VIEWS: WorkspaceViewDefinition[] = [
  {
    id: 'graph',
    label: 'Graph',
    route: 'graph',
    icon: 'network',
    description: 'Build the structure of the model.',
    requiresSimulation: true
  },
  {
    id: 'inputs',
    label: 'Sensitivity',
    route: 'inputs',
    icon: 'sliders',
    description: 'Review assumptions and sensitivity drivers.',
    requiresSimulation: true
  },
  {
    id: 'sheet',
    label: 'Sheet',
    route: 'sheet',
    icon: 'table',
    description: 'Inspect every formula, distribution, and value in a spreadsheet.',
    requiresSimulation: true
  },
  {
    id: 'scenarios',
    label: 'Scenarios',
    route: 'scenarios',
    icon: 'branch',
    description: 'Compare alternate input assumptions.',
    requiresSimulation: true
  },
  {
    id: 'results',
    label: 'Results',
    route: 'results',
    icon: 'chart',
    description: 'Inspect outputs and run results.',
    requiresSimulation: true
  }
];

export const isWorkspaceView = (value: string | null | undefined): value is WorkspaceView =>
  WORKSPACE_VIEWS.some((view) => view.id === value);

export const resolveWorkspaceView = (value: string | null | undefined): WorkspaceView =>
  isWorkspaceView(value) ? value : DEFAULT_WORKSPACE_VIEW;

interface ViewState {
  activeView: WorkspaceView;
  setActiveView: (view: WorkspaceView) => void;
}

export const useViewStore = create<ViewState>((set) => ({
  activeView: DEFAULT_WORKSPACE_VIEW,
  setActiveView: (view) => set({ activeView: view }),
}));
